import { NavLink } from "react-router-dom";
import { Tag, Archive, RefreshCcw } from "lucide-react";

const TABS = [
  ["/depot/etiquette", "Étiquette colis", Tag, "etiquette"],
  ["/depot/casiers", "Étiquettes casiers", Archive, "casiers"],
  ["/depot/etiquette-reprise", "Étiquette reprise", RefreshCcw, "reprise"],
];

export function EtiquettesTabs() {
  return (
    <div className="flex flex-wrap gap-2 mb-4" data-testid="etiquettes-tabs">
      {TABS.map(([to, label, Icon, key]) => (
        <NavLink key={to} to={to} data-testid={`etiquettes-tab-${key}`}
          className={({ isActive }) => `inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium border ${isActive ? "bg-primary text-primary-foreground border-primary" : "border-input hover:bg-accent"}`}>
          <Icon size={15} />{label}
        </NavLink>
      ))}
    </div>
  );
}
